<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <lottery-report-table></lottery-report-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import LotteryReportTable from './LotteryReportTable.vue'

  export default {
    name: 'lottery-report',
    components: {LotteryReportTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/report/mini-games/lottery/LotteryReport.vue